module.exports = __webpack_public_path__ + "static/media/self.1034e864.jpeg";